import type { utils } from 'blockly/core';

import { categoryCssConfig } from '../categoryCssConfig.js';
import { BEGINNER_SERIAL_COLOR } from './constants.js';

type ToolboxItemInfo = utils.toolbox.ToolboxItemInfo;

/** Beginner Serial Monitor category — send and receive friendly data blocks. */
export function buildBeginnerSerialMonitorCategory(): ToolboxItemInfo {
  return {
    kind: 'category',
    name: 'Serial Monitor',
    colour: String(BEGINNER_SERIAL_COLOR),
    cssconfig: categoryCssConfig('serial'),
    contents: [
      {
        kind: 'block',
        type: 'beginner_serial_send',
        inputs: {
          VALUE: {
            shadow: {
              type: 'text',
              fields: { TEXT: 'Hello' },
            },
          },
        },
      },
      {
        kind: 'block',
        type: 'beginner_serial_send_character',
        inputs: {
          CHAR: {
            shadow: {
              type: 'text_char',
              fields: { CHAR: 'A' },
            },
          },
        },
      },
      {
        kind: 'block',
        type: 'beginner_serial_send_line',
        inputs: {
          VALUE: {
            shadow: {
              type: 'text',
              fields: { TEXT: 'Hello' },
            },
          },
        },
      },
      { kind: 'block', type: 'beginner_serial_received_character' },
      { kind: 'block', type: 'beginner_serial_received_number' },
      { kind: 'block', type: 'beginner_serial_received_text' },
      { kind: 'block', type: 'beginner_serial_data_available' },
      { kind: 'block', type: 'beginner_serial_wait_data' },
    ],
  };
}
